import { render } from "./DialogScene.vue?vue&type=template&id=09bb31b7&scoped=true"
import script from "./DialogScene.vue?vue&type=script&lang=js"
export * from "./DialogScene.vue?vue&type=script&lang=js"

import "./DialogScene.vue?vue&type=style&index=0&id=09bb31b7&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bb31b7"]])

export default __exports__